 
     
    require('datatables.net');
	require('datatables.net-bs4'); 
	require('datatables.net-responsive');
	require('datatables.net-responsive-bs4');
  
    import { Options, Vue   } from "vue-class-component";   
    import jQuery  from 'jquery';   
    import { Prop , Watch } from 'vue-property-decorator';
    import ApiService from "@/service/ApiService"; 
 
    @Options({
        name: "KDataTable",
        components: { },  
    }) 
    export default class KDataTable extends Vue {
 
        @Prop({required: true}) readonly config!: any 
        @Prop({required: false})  reload!: boolean
        @Prop({required: false , default:true })  pesquisar!: boolean 
        @Prop({required: false , default:'tableatualizada' })  evento!: any
 
        private datatable: any = null;
		public id: any = null;
     
        @Watch('reload')
		tabelaAtualizada(newVal: string) {
			this.datatable.ajax.reload(); 
		}
        
        public apertouEnter(e){ 
            if(e.key === 'Enter' || e.keyCode === 13){
                setTimeout(() => {
                    this.tabelaAtualizada('');
                }, 300); 
            }
        }

        created(){
			this.id = Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15); 
		}
 
        mounted() {
			this.datatable = this.montarDatatable( );   
		}

        private montarParametrosAjaxPadrao(d: any) {
            const dados: Record<string, string | number | boolean | null> = {
                "Skip": d.start,
                "Take": d.length,
                "search": d.search ? d.search.value : null
            };

            if (d.order && d.order.length > 0) {
                d.order.forEach((orderConfig, index) => {
                    const columnConfig = d.columns ? d.columns[orderConfig.column] : null;
                    const direction = orderConfig ? orderConfig.dir : null;

                    dados["order" + index] = columnConfig ? columnConfig.name : null;
                    dados["asc" + index] = direction === "asc" ? true : direction === "desc" ? false : null;
                });
            }

            return dados;
        }

        private padronizarAjaxData(config: any) {
            const ajaxData = config.ajax ? config.ajax.data : null;
            const montarParametrosAjaxPadrao = (d) => this.montarParametrosAjaxPadrao(d);

            config.ajax.data = function (d, settings) {
                const dadosPadrao = montarParametrosAjaxPadrao(d);

                if (typeof ajaxData === "function") {
                    const dadosTela = ajaxData.call(this, d, settings);
                    return jQuery.extend(true, {}, dadosPadrao, dadosTela);
                }

                if (ajaxData && typeof ajaxData === "object") {
                    return jQuery.extend(true, {}, dadosPadrao, ajaxData);
                }

                return dadosPadrao;
            };
        }
 
		public montarDatatable(  ) {   
				const seletorTabela = '#' + this.id ;   
                const configPadrao = {
                    lengthMenu:  [ [ 5, 10, 15, 25, 40, 50, -1], [5, 10, 15, 25, 40, 50, "Todos"] ],
                    bStateSave: false,
                    dom:  "<'row'<'col-xs-12'<'col-xs-12'><'col-xs-12' >>r>" + "<'row'<'col-xs-12't>>" + "<'row'<'col-lg-3'l><'col-lg-6'p><'col-lg-3'i>>", // "<'row'<'col-lg-12'<'col-lg-12'><'col-lg-12' >>r>"+ "<'row'<'col-lg-12't>>"+ "<'row'<'col-lg-4'i><'col-lg-8'p>>",
                    searchDelay: 500,
                    processing: true,
                    serverSide: true, 
                    responsive: true,
                    stateSave: true,
                    select: {
                        style: 'multi',
                        selector: 'td:first-child input[type="checkbox"]',
                        className: 'row-selected'
                    },
                    fnStateSave: function (oSettings, oData) {
                        // localStorage.setItem( 'DataTables', JSON.stringify(oData) );
                    },
                    fnStateLoad: function (oSettings) {
                        return null;
                    }, 
                    ajax: {
                        type: 'get',	 
                        headers: ApiService.getHeader() ,
                        dataFilter: function(data){
                            var json = jQuery.parseJSON( data );
                            json.recordsTotal = json.total;
                            json.recordsFiltered = json.total; 
                            return JSON.stringify( json ); 
                        },
                        data: function ( d ) {  
                            const dados = {
                                "Skip": d.start,
                                "Take": d.length,
                                "search": d.search.value
                            }
                            return dados; 
                        }  
                    }, 
					language: { 
                        "sEmptyTable": "Nenhum registro encontrado",
                        "sInfo": "Mostrando de _START_ até _END_ de _TOTAL_ registros",
                        "sInfoEmpty": "Mostrando 0 até 0 de 0 registros",
                        "sInfoFiltered": "(Filtrados de _MAX_ registros)",
                        "sInfoPostFix": "",
                        "sInfoThousands": ".",
                        "sLengthMenu": "_MENU_ resultados por página",
                        "sLoadingRecords": "Carregando...",
                        "sProcessing": "Processando...",
                        "sZeroRecords": "Nenhum registro encontrado",
                        "sSearch": "Pesquisar",
                        "oPaginate": {
                            "sNext": "Próximo",
                            "sPrevious": "Anterior",
                            "sFirst": "Primeiro",
                            "sLast": "Último"
                        },
                        "oAria": {
                            "sSortAscending": ": Ordenar colunas de forma ascendente",
                            "sSortDescending": ": Ordenar colunas de forma descendente" 
                        }
					}, 
   
			    }; 
			     
				const config = jQuery.extend(true, {}, configPadrao , this.config );
                this.padronizarAjaxData(config);
				jQuery.fn.dataTable.ext.errMode = 'none'; 
				const dataTable = jQuery(seletorTabela).DataTable(config);  
				dataTable.on( 'draw',   () => {
					this.$emit( this.evento , this.datatable.ajax.params() );  
				});
 
                dataTable.on( 'click.tr', (e) => {
                    var data = null;
                    if(jQuery(e.target).is("td")) {
                        data = dataTable.row( e.target._DT_CellIndex.row ).data() ; 
                    }
                    else{
                        data = dataTable.row( jQuery(e.target).parents("td").first()[0]._DT_CellIndex.row ).data() ; 
                    } 
					this.$emit( 'clicou_linha' , data );  
				});
 
                const filterSearch = document.querySelector('[data-kt-docs-table-filter="search'+ this.id +'"]');
                if(filterSearch){
                    filterSearch!.addEventListener('keyup', function ( this , e  ) { 
                    if (e.type === 'change' || ( e as KeyboardEvent).key === 'Enter') {
                        dataTable.search(this.value).draw();
                    }
                }); 
            } 
            return dataTable;
		} 
    }
 
